import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import { Link, Navigate } from "react-router-dom";

//i18n
import { withTranslation } from "react-i18next";

//import images
import logoSm from "../../assets/images/only-switch-icon.png";
import logoDark from "../../assets/images/only-switch-logo-white-inset.png";
// import logoLight from "../../assets/images/only-switch-logo-white-inset.png";
import logoLight from "../../assets/images/sixbit-logo-bg.jpg";

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
} from "../../store/actions";
import ProfileMenu from "../../components/Common/TopbarDropdown/ProfileMenu";

const Header = (props) => {
  const [appInfo, setAppInfo] = useState();

  const { currentProfile } = props;
  const { applicationLogo, applicationName } = currentProfile || {};
  let title;

  useEffect(() => {
    setAppInfo({
      applicationLogo: applicationLogo,
      applicationName: applicationName
    });
  }, [currentProfile]);

  function tToggle() {
    var body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  }

  if (appInfo && appInfo.applicationName) {
    title = appInfo.applicationName;
  }
  else {
    title = window.__ENV && window.__ENV.projectTitle;
  }

  const { isAuth } = props;
  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box text-center">
              <Link to="/" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logoSm} alt="logo-sm-dark" width="40" />
                </span>
                <span className="logo-lg">
                  <img src={(appInfo && appInfo.applicationLogo) ? appInfo.applicationLogo : logoDark} alt="logo-dark" height="60" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoSm} alt="logo-sm-light" width="40" />
                </span>
                <span className="logo-lg">
                  <img src={(appInfo && appInfo.applicationLogo) ? appInfo.applicationLogo : logoLight} alt="logo-light" height="60" />
                </span>
              </Link>
            </div>

            <button
              type="button"
              className="btn btn-sm px-3 font-size-24 header-item waves-effect"
              id="vertical-menu-btn"
              onClick={() => {
                tToggle();
              }}
            >
              <i className="ri-menu-2-line align-middle"></i>
            </button>
          </div>
          <div className="fs-4 fw-bolder text-dark">
            {title}
          </div>
          <div className="d-flex">
            <ProfileMenu />
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  const { layoutType, showRightSidebar, leftMenu, leftSideBarType } = state.Layout;
  const { isAuth, currentProfile } = state.login;
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType, isAuth, currentProfile };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header));
